import React from "react";
import { Footer } from "../component/Footer";
import banner6 from "../img/About2.jpg";
import mission from "../img/mission1.jpg";
import success from "../img/success.jpg";

function About() {
  return (
    <div>
      <img
        className="d-block w-100"
        src={banner6}
        alt="Banner"
        style={{ height: "150px", objectFit: "cover" }}
      />
      <center>
        <h1 className="about mt-5">About Arc Solutions</h1>
      </center>

      <div className="container mt-4">
        <div className="row">
          <p style={{ textAlign: "center" }}>
            Arc Solutions is a leading IT Solution provider company based in
            India With Strong Focus towards, topof- the-line Web Application
            Development, E- Commerce portal development, ERP Solutions, Software
            Development, Website Designing, Dynamic Website Designing, Mobile
            App Development, SEO/SMO Services, Online Marketing, Web Portal
            Development, in simple words we are one stop solution centre for all
            your IT needs by using the latest technologies available in the
            market. We follow a quality driven step by step standard software
            development methodology to provide an end-to – end scalable, secure,
            modular and creative business solutions that meets the business
            objectives &amp; reflects the need &amp; vision of our esteemed
            client. We provide Different services in multifarious organizations
            like Industries, Real Estate, Hospitals, Schools, Hospitality,
            Government sector and many more.
            <br />
            <br />
            Our biggest strength is our people, our team, our family; everyone
            working at Arc is very enthusiastic &amp; young with lots of energy
            &amp; vigor to deliver its 100% for all your technology needs:
            strategy, business intelligence, system architect, design,
            implementation, integration &amp; support. Our environment fosters
            the individual growth of all of our people &amp; we are proud to
            help in transforming our people into future leader of IT Industry.
            We aspire to work in long term partnership with our clients, a
            relationship that characterized by mutual trust, respect &amp;
            honesty.
            <br />
            <br />
            In last but not the least, our motto is to provide businesses across
            the globe with world class IT solutions to enhance &amp; compliment
            business which results success &amp; growth that has been powered by
            our consultative approach. Our deep understanding of business &amp;
            importantly "Our Passion for Innovation "
          </p>
        </div>

        <div className="contianer">
          <div className="row mt-5">
            <div className="col-md-5 ms-3">
              <img className="" src={mission} alt="about" />
            </div>
            <div className="col-md-6 ms-3">
              <h2 className="fw-bold;">Our Mission:</h2>
              <p className=" fs-5">
                Our mission at Arc Solutions is to be innovative & fluent to the
                client need & provide them advance quality products & solutions
                of their all IT needs by achieving Excellency in projects
                execution , quality , reliability , safety & operational
                efficiency : To be a partner in national building & contribute
                towards India's , economic growth by encouraging new ideas, new
                talents & value system which makes us the employer of choice ;
                To enhance the technology exposures of the "IT Companies" in a
                globalizing competitive environment with an endeavor to learn,
                improve & "Deliver Extra Ordinary Solutions With High Quality
                Services"
              </p>
            </div>
          </div>
        </div>

        <div className="contianer">
          <div className="row mt-5">
            <div className="col-md-6 ms-3">
              <h2 className="fw-bold;">Our Success:</h2>
              <p className=" fs-5">
                Our mission at Arc Solutions is to be innovative & fluent to the
                client need & provide them advance quality products & solutions
                of their all IT needs by achieving Excellency in projects
                execution , quality , reliability , safety & operational
                efficiency : To be a partner in national building & contribute
                towards India's , economic growth by encouraging new ideas, new
                talents & value system which makes us the employer of choice ;
                To enhance the technology exposures of the "IT Companies" in a
                globalizing competitive environment with an endeavor to learn,
                improve & "Deliver Extra Ordinary Solutions With High Quality
                Services"
              </p>
            </div>
            <div className="col-md-5 ms-3">
              <img className="" src={success} alt="about" />
            </div>
          </div>
        </div>
      </div>

      

      <Footer />
    </div>
  );
}

export default About;
